export default "__VITE_ASSET__CJ4Z5KBZ__"